import Moment from 'moment';

// Shared view-only formatters for dates/times shown across the app -
// standardizing on M/D/YYYY for dates and h:mm A (12-hour, AM/PM) for
// times, per product request. These never touch what gets sent back to
// the API on submit - only how an already-saved value is displayed.
//
// Uses Moment.utc() rather than plain Moment(value), for the same reason
// eventDateTime.js does (see its comment): the API sends timestamps as
// UTC ISO strings representing the literal wall-clock value to show, not
// a moment in time to convert to the viewer's local timezone. Parsing
// with plain Moment() shifts the date/time by the viewer's UTC offset -
// this was the exact cause of an earlier bug where the student dashboard
// showed the wrong date for US/Canada users. Formatting a bare
// "HH:mm:ss" time-of-day string (no date component, e.g. a medication's
// times_to_be_administered) through Moment.utc() would incorrectly
// resolve it against today's date in UTC, so formatDisplayTime falls
// back to parsing it as a plain time-of-day when it doesn't look like a
// full ISO datetime.

export function formatDisplayDate(value, format = 'M/D/YYYY') {
    if (!value) {
        return 'N/A';
    }
    const parsed = Moment.utc(value);
    return parsed.isValid() ? parsed.format(format) : 'N/A';
}

export function formatDisplayTime(value, format = 'h:mm A') {
    if (!value) {
        return 'N/A';
    }
    const stringValue = String(value);
    // A bare time-of-day ("HH:mm:ss" / "HH:mm"), not a full ISO datetime -
    // has no date/timezone to account for, so parse it directly.
    if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(stringValue.trim())) {
        const bareTime = Moment(stringValue.trim(), ['HH:mm:ss', 'HH:mm'], true);
        return bareTime.isValid() ? bareTime.format(format) : 'N/A';
    }
    const parsed = Moment.utc(value);
    if (parsed.isValid()) {
        return parsed.format(format);
    }
    const bareTime = Moment(stringValue, ['hh:mm A', 'hh:mm a'], true);
    return bareTime.isValid() ? bareTime.format(format) : 'N/A';
}
